const translatedTime = {
  second: 'segundo',
  seconds: 'segundos',
  minute: 'minuto',
  minutes: 'minutos',
  hour: 'hora',
  hours: 'horas',
  lesson: 'lição',
  lessons: 'lições',
  session: 'sessão',
  sessions: 'sessões',
  day: 'dia',
  days: 'dias',
  week: 'semana',
  weeks: 'semanas',
  month: 'mês',
  months: 'meses',
  term: 'termo',
  terms: 'termos',
  semester: 'semestre',
  semesters: 'semestres',
  year: 'ano',
  years: 'anos',
  unit: 'unidade',
  units: 'unidades',
  fixed: 'fixado',
};

export default translatedTime;
